module.exports = "<p>\n  view-submission works!\n</p>\n"